<template>
  <div
    tabindex="0"
    class="dropdown"
    :class="bodyClass"
    @keydown.up.prevent="activate"
    @keydown.down.prevent="activate"
    @keydown.enter.prevent="deactivate"
    @blur.prevent="deactivate"
    @keyup.esc.prevent="deactivate"
  >
    <div
      class="dropdown-toggle d-flex align-items-center"
      @mousedown.prevent="toggle"
    >
      <div
        v-if="value"
        class="color preview"
        :style="{ backgroundColor: value.code }"
      />
      <div v-else>색상</div>
    </div>
    <ul class="dropdown-menu flex-wrap" v-show="activation">
      <li
        :key="color.id"
        v-for="color in colors"
        class="color"
        :style="{ backgroundColor: color.code }"
        @click="select(color)"
      />
    </ul>
  </div>
</template>

<script>
export default {
  props: ["colors", "value", "bodyClass"],
  data() {
    return {
      activation: false
    };
  },
  watch: {
    activation() {
      if (!this.activation) {
        return;
      }

      this.$el.focus();
    }
  },
  methods: {
    toggle() {
      this.activation = !this.activation;
    },
    activate() {
      this.activation = true;
    },
    deactivate() {
      this.activation = false;
    },
    select(color) {
      if (this.value === color) {
        this.$emit("input", null);
      } else {
        this.$emit("input", color);
      }

      this.activation = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown {
  min-width: 100px;
}

.dropdown:focus {
  outline-width: 0;
}

.dropdown-toggle {
  cursor: pointer;
  &::after {
    position: absolute;
    right: 0;
  }
}

.dropdown-menu {
  display: flex;
  padding: 5px;
  width: 312px;
  left: auto;
  right: 0;
}

.color {
  cursor: pointer;
  height: 40px;
  width: 40px;
  margin: 5px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;

  &.preview {
    margin: 0;
    height: 19px;
    width: 19px;
  }
}
</style>
